const dialog = () => document.getElementById('MenuDrawer');

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-open-menu]');
  if (opener) {
    const d = dialog();
    if (!d || d.open) return;
    d.showModal();
    document.body.classList.add('overflow-hidden');
    return;
  }
  if (event.target.closest('[data-close-menu]')) dialog()?.close();
  const d = dialog();
  if (d && event.target === d) d.close();
});

document.addEventListener('close', (event) => {
  if (event.target.id === 'MenuDrawer') document.body.classList.remove('overflow-hidden');
}, true);

document.addEventListener('click', (event) => {
  if (!event.target.closest('[data-focus-search]')) return;
  window.scrollTo({ top: 0, behavior: 'instant' });
  // El header condensado oculta el buscador móvil; se expande ya, dentro del gesto (iOS exige foco síncrono).
  document.querySelector('b-sticky-header')?.classList.remove('is-condensed');
  document.getElementById('Search-Mobile')?.focus();
});
